export default "__VITE_ASSET__BPj6kTn8__"